module.exports = __webpack_public_path__ + "img/leave.d9802a80.png";